module.exports = __webpack_public_path__ + "static/media/inquiry_form_current.79c0f9f7.svg";